import { useState } from "react";
import styled from "styled-components";
import {
  // Box,
  Flex,
  HelpIcon,
  LinkExternal,
  Text,
  TimerIcon,
  useMatchBreakpoints,
} from "@pancakeswap/uikit";
import NameCell from "./Cells/NameCell";
import EarningsCell from "./Cells/EarningsCell";
import IFOCreditCell from "./Cells/IFOCreditCell";
import AprCell from "./Cells/AprCell";
import TotalStakedCell from "./Cells/TotalStakedCell";
import EndsInCell from "./Cells/EndsInCell";
import ExpandActionCell from "./Cells/ExpandActionCell";
import ActionPanel from "./ActionPanel/ActionPanel";
import AutoEarningsCell from "./Cells/AutoEarningsCell";
import StakedCell from "./Cells/StakedCell";
import { AccordionDetails, AccordionSummary } from "@mui/material";
import MuiAccordion from "@mui/material/Accordion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EndBlocks from "./Cells/EndBlocks";
import { Box } from '@mui/material'
import AprRow from "../PoolCard/AprRow";
interface PoolRowProps {
  pool: any;
  index: any;
  account: string;
  userDataLoaded: boolean;
  price: number
}

export enum VaultKey {
  CakeVault = "cakeVault",
  IfoPool = "ifoPool",
}

const StyledRow = styled.div`
  background-color: transparent;
  display: flex;
  cursor: pointer;
`;

const InfoSection = styled(Box)`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: auto;
  padding: 8px 8px;
  ${({ theme }) => theme.mediaQueries.lg} {
    padding: 0;
    flex-basis: 230px;
  }
`;

const RequirementSection = styled(Box)`
  display: flex;
  justify-content: space-between;

  ${({ theme }) => theme.mediaQueries.lg} {
    display: inline-block;

    > div {
      display: inline;
      margin-right: 4px;
    }
  }
`;

const AutoTag = styled.div`
  align-items: center;
  border-radius: 16px;
  display: inline-flex;
  font-weight: 400;
  white-space: nowrap;
  height: 28px;
  padding: 0 8px;
  font-size: 14px;
  color: #31d0aa;
  background: #faf9fa;
  border: 2px solid #31d0aa;
`;
const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px `,
}))


const PoolRow: React.FC<PoolRowProps> = ({ pool, index, account, userDataLoaded, price }) => {
  const { isXs, isSm, isMd, isLg, isXl, isXxl, isTablet, isDesktop } =
    useMatchBreakpoints();
  const isLargerScreen = isLg || isXl || isXxl;
  const isXLargerScreen = isXl || isXxl;
  const [expanded, setExpanded] = useState(false);
  const shouldRenderActionPanel = true;

  const toggleExpanded = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <>
      <Box sx={{
        // background: '#00202F'
      }}>
        <Accordion
          sx={{
            backgroundColor: '#00202F',
            borderRadius: "30px",
            // borderBottomLeftRadius: "20px",
            // borderBottomRightRadius: "20px",
            // borderTopLeftRadius: "30px", 
            // borderTopRightRadius: "30px",
          }}
        >
          <AccordionSummary sx={{
            minHeight: '80px',
            height: "100%",
            pb: '10px',
            ml: 0,
          }}
            expandIcon={<ExpandMoreIcon sx={{ color: "#00FED9" }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Box sx={{ display: { xs: 'block', sm: 'flex', md: 'flex', lg: 'flex', xl: 'flex' }, width: '100%' }}>
              <Box sx={{ width: { sm: '200px' }, marginRight: { md: '50px', sm: '50px' } }}>
                <NameCell pool={pool} />
              </Box>
              <Box sx={{ display: 'flex', pt: { xs: '15px', sm: '0px', md: '0px', lg: '0px', xl: '0px' } }}>
                <Box sx={{ flex: { md: 4, sm: 4, xs: 4 }, minWidth: "80px" }}>
                  <AutoEarningsCell price={price} pool={pool} account={account} />
                </Box>
                <Box sx={{ flex: { md: '4', sm: '4', xs: '4' }, overflow: { xs: 'hidden', md: 'hidden', lg: 'hidden', xl: 'hidden' }, minWidth: "100px" }}>
                  <AprCell pool={pool} index={index} />
                  {/* <AutoEarningsCell pool={pool} account={account} /> */}
                </Box>
              </Box>
            </Box>
            {/* <Box sx={{ display: { xs: 'none', sm: 'block', md: 'block', lg: 'block' } }}>
              <AprRow pool={pool} index={index} />
            </Box> */}
            <Box sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' } }}>
              <TotalStakedCell pool={pool} />
            </Box>
            <Box sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' } }}>
              <EndBlocks pool={pool} />
            </Box>
            {/* {isDesktop && <EndsInCell pool={pool} />} */}
          </AccordionSummary>
          <AccordionDetails sx={{ p: 0, }}>
            <ActionPanel
              account={account}
              pool={pool}
              index={index}
              price={price}
              userDataLoaded={userDataLoaded}
              expanded={expanded}
              breakpoints={{ isXs, isSm, isMd, isLg, isXl, isXxl }}
            />
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  );
};

export default PoolRow;
